import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getIcon } from '../icons-definition';

interface IconProps {
    icon: string;
    className?: string;
}

export default function Icon({ icon, className }: IconProps): JSX.Element {
    const cls = 'icon ' + (className || '');
    const html = useMemo(() => ({ __html: getIcon(icon) }), [icon]);

    return <span className={cls} dangerouslySetInnerHTML={html} />;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(Icon as any).propTypes = {
    icon: PropTypes.string.isRequired,
};
